// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fce1a479","455":"e1eec66f","977":"8b278be0"}[chunkId] + ".chunk.js";
};